import { OnInit } from '@angular/core';
import { ConfigService } from '../../config/config.service';
import { CalendlyService } from '../../config/calendly.service';
import { DataLayerService } from '../../shared/services/data-layer.service';
import { AmplitudeService } from '../../shared/services/amplitude.service';
import { AccountService } from '../../shared/services/account.service';
import { AlertPaymentService } from '../../shared/services/alert-payment.service';
import { isCurrentRouteBlocked } from '../../../../old-crazy-web-frontend/src/app/auth/blocked-state-routes';
var LeftMenuComponent = /** @class */ (function () {
    function LeftMenuComponent(configService, calendlyService, dataLayerService, amplitudeService, accountService, alertPaymentService) {
        this.configService = configService;
        this.calendlyService = calendlyService;
        this.dataLayerService = dataLayerService;
        this.amplitudeService = amplitudeService;
        this.accountService = accountService;
        this.alertPaymentService = alertPaymentService;
        this.hostClass = 'app-aside modal fade nav-dropdown';
        this.hostId = 'aside';
    }
    LeftMenuComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.accountService.isAccountSet$.subscribe(function () {
            _this.alertPaymentService.onActivatePaymentAlert.subscribe(function (isPaymentFailed) {
                _this.failedPayment = isPaymentFailed;
            });
            _this.alertPaymentService.alertUnpaidStatus();
        });
    };
    Object.defineProperty(LeftMenuComponent.prototype, "blurred", {
        get: function () {
            return isCurrentRouteBlocked();
        },
        enumerable: true,
        configurable: true
    });
    LeftMenuComponent.prototype.openCalendly = function () {
        this.dataLayerService.logEvent('getDemo');
        this.amplitudeService.logEvent('Panel: Page View: Get Demo');
        this.calendlyService.openCalendly();
    };
    return LeftMenuComponent;
}());
export { LeftMenuComponent };
